import { DownloadLoanAgreementProps, InvestInPrimaryMarketItemProps } from 'models/api';

import BaseApi from './BaseApi';

export class LoansApi extends BaseApi {
	constructor() {
		super('/loans');
	}
	invest({ id, body }: InvestInPrimaryMarketItemProps) {
		return this.httpClient.post({
			url: `/${id}`,
			conditions: { auth: true },
			body,
		});
	}

	getAgreement({ amount, id }: DownloadLoanAgreementProps) {
		return this.httpClient.get({
			url: `/${id}/agreement/${amount}`,
			conditions: { auth: true },
			config: {
				responseType: 'blob',
			},
		});
	}
}
export const LoansService = new LoansApi();
